import { h, Component } from 'preact'
import axios, { AxiosResponse } from 'axios'
import { User } from './User'
import Selector from '../selector/Selector'
import UserAvatar from '../User/UserAvatar'

interface Props {
  url: string,
  onChange: Function,
  error: boolean
}

interface State {}

class UserSelector extends Component<Props, State> {
  validateUser = (userName: string) => {
    return axios
      .get(`${this.props.url}${userName}`)
      .then((response: AxiosResponse) => {
        const matchedUser = response.data.length === 1 && response.data[0].name === userName
        return matchedUser
          ? response.data[0]
          : null
      })
  }

  render (props: Props, state: State) {
    return <div class='user-selector'>
      <Selector
        config={{
          dynamic: {
            baseUrl: props.url,
            omitItemsKey: 'id',
            dynamicItemElement: (item: User) => <UserItem user={item} />
          },
          itemElement: (item: User) => <UserItem user={item} />,
          itemToStringKey: 'name',
          delimiter: ',',
          keys: {
            insert: ['Enter', 'Tab', ',', ';'],
            remove: ['Backspace']
          }
        }}
        onValidate={(value: string) => this.validateUser(value)}
        onChange={(users: Array<User>) => props.onChange(users)}
        error={props.error}
      />
    </div>
  }
}

const UserItem = ({ user } : { user: User}) =>
  <div>
    { user.id && <UserAvatar user={user} />}
    <span>{user.name}</span>
  </div>

export default UserSelector
